const tasks = {
    tasks:'Tasks',
    addNewTask:'Add New Task',
    dashboardView:'Dashboard View',
    completedTasks:'Completed Tasks',
    inCompleteTasks:'InComplete Tasks',
    overdueTasks:'Overdue Tasks',
    totalTasks:'Total Tasks',
    createAppointment:'Create Appointment',

    tasksModal:{
        addTask:'Add Task',
        title:'Title',
        longDescription:'Long Description',
        status:'Status',
        priority:'Priority',
        to:'Assign To',
        patient:'Patient',
        staff:'Staff',
        assignedTo:'Assigned To',
        category:'Category',
        startDate:'Start Date',
        dueDate:'Due Date',

    }


  }


export default tasks